import { createRouter, createWebHistory } from "vue-router";
import commonFunc from "@/common/commonFunc";
import Page from "@/pages/Page.vue";
import Event from "@/views/event/EventList.vue";
import Product from "@/views/product/ProductList.vue";
import Category from "@/views/category/CategoryList.vue";
import Supplier from "@/views/supplier/SupplierList.vue";
import Order from "@/views/order/OrderList.vue";
import Customer from "@/views/customer/CustomerList.vue";
// import Shipper from "@/views/shipper/ShipperList.vue";
import SaleEmployee from "@/views/saleEmployee/SaleEmployeeList.vue";
import HelpSupport from "@/views/helpSupport/HelpSupportList.vue";
import UserManager from "@/views/user/UserManager.vue";
import AboutMe from "@/views/aboutMe/AboutMeList.vue";
import Login from "@/views/user/Login.vue";
import Dashboard from "@/views/dashboard/Dashboard.vue";
import ProductDetail from "@/views/product/ProductDetail.vue";
import OrderDetail from "@/views/order/OrderDetail.vue";
import CategoryDetail from "@/views/category/CategoryDetail.vue";
import SupplierDetail from "@/views/supplier/SupplierDetail.vue";
import SaleEmployeeDetail from "@/views/saleEmployee/SaleEmployeeDetail.vue";
import ShipperDetail from "@/views/shipper/ShipperDetail.vue";
import CustomerDetail from "@/views/customer/CustomerDetail.vue";
import OrderItemDetail from "@/views/order/ItemDetail.vue";
import UserDetail from "@/views/user/UserDetail.vue";
import GroupDetail from "@/views/user/GroupDetail.vue";
const routes = [
  {
    path: "/",
    name: "home",
    component: Page,
    children: [
      {
        name: "dashboard",
        path: "/dashboard",
        component: Dashboard,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "event",
        path: "/event",
        component: Event,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "product",
        path: "/product",
        component: Product,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "category",
        path: "/category",
        component: Category,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "supplier",
        path: "/supplier",
        component: Supplier,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "order",
        path: "/order",
        component: Order,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "customer",
        path: "/customer",
        component: Customer,
        props: true,
        meta: { requiresAuth: true },
      },
      // {
      //   name: "shipper",
      //   path: "/shipper",
      //   component: Shipper,
      //   props: true,
      //   meta: { requiresAuth: true },
      // },
      {
        name: "sale-employee",
        path: "/sale-employee",
        component: SaleEmployee,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "help-support",
        path: "/help-support",
        component: HelpSupport,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "usermanager",
        path: "/user-manager",
        component: UserManager,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "about-me",
        path: "/about-me",
        component: AboutMe,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "createproduct",
        path: "/create-product",
        component: ProductDetail,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "createcategory",
        path: "/create-category",
        component: CategoryDetail,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "createorder",
        path: "/create-order",
        component: OrderDetail,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "createsupplier",
        path: "/create-supplier",
        component: SupplierDetail,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "createemployee",
        path: "/create-employee",
        component: SaleEmployeeDetail,
        props: true,
        meta: { requiresAuth: true },
      },

      {
        name: "createshipper",
        path: "/create-shipper",
        component: ShipperDetail,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "createcustomer",
        path: "/create-customer",
        component: CustomerDetail,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "createitem",
        path: "/create-item",
        component: OrderItemDetail,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "createuser",
        path: "/create-user",
        component: UserDetail,
        props: true,
        meta: { requiresAuth: true },
      },
      {
        name: "creategroup",
        path: "/create-group",
        component: GroupDetail,
        props: true,
        meta: { requiresAuth: true },
      },
    ],
    meta: { requiresAuth: true },
  },
  {
    name: "login",
    path: "/login",
    component: Login,
    props: true,
    meta: { requiresAuth: false },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  //check update menu Active
  // config.menus.forEach((menu) => {
  //   menu.isActive = menu.router === to.path;
  //   if (menu.isActive) {
  //     store.commit("updateMenuActive", menu);
  //   }
  // });

  if (requiresAuth && commonFunc.isTokenExpired()) {
    next("/login");
    ư;
  } else {
    next();
  }
});

export default router;
